import { render, staticRenderFns } from "./AdminPuzzleItem.vue?vue&type=template&id=08e356d5"
import script from "./AdminPuzzleItem.vue?vue&type=script&lang=ts"
export * from "./AdminPuzzleItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports